import React, { HTMLAttributes } from 'react'
import classNames from 'classnames'
import { CaretLeftIcon } from '@/atoms/Icons/CaretLeftIcon'
import { InternalLink } from '@/atoms/InternalLink'
import { paths } from '@/constants/paths'
import { slugs } from '@/constants/slugs'
import { useSafeTrack } from '@/utils/analytics/safe-analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { AsSpan, ParagraphSM } from '../Text'

interface BreadcrumbProps extends HTMLAttributes<HTMLElement> {
  projectSlug: string
  projectName: string
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ className, projectSlug, projectName }) => {
  const { t } = useTranslate('common')
  const track = useSafeTrack()

  const handleWatchPageClick = () => {
    track('Breadcrumb Watch Page Clicked', {
      projectSlug,
      projectName,
    })
  }

  const handleProjectClick = () => {
    track('Breadcrumb Project Clicked', {
      projectSlug,
      projectName,
    })
  }

  return (
    <div className={classNames('line-clamp-1 pl-4', className)}>
      <InternalLink href={`${paths.watch.index}/${projectSlug}`} onClick={handleProjectClick}>
        <CaretLeftIcon className="mr-2 inline" color="white" />
      </InternalLink>
      <ParagraphSM className="text-white" as={AsSpan}>
        <InternalLink href={paths.watch.index} onClick={handleWatchPageClick}>
          {t('watch', 'Watch')}
        </InternalLink>
      </ParagraphSM>
      {projectSlug !== slugs.forYourConsideration && (
        <>
          <ParagraphSM className="mx-2 text-core-gray-600" as={AsSpan}>
            /
          </ParagraphSM>
          <ParagraphSM className="text-white" as={AsSpan}>
            <InternalLink href={`${paths.watch.index}/${projectSlug}`} onClick={handleProjectClick}>
              {projectName}
            </InternalLink>
          </ParagraphSM>
        </>
      )}
    </div>
  )
}
